<template>
  <div id="auth" class="container align-all">
    <section id="auth-content" class="box padding install">
      <h2>Criar nova senha</h2>
      <form class="margin-top-l">
        <div class="item">
          <div class="flex between">
            <label>Nova senha</label>
          </div>
          <input v-model="password1" type="password" />
        </div>
        <div class="item">
          <div class="flex between">
            <label>Repita a senha:</label>
          </div>
          <input v-model="password2" type="password" />
        </div>
      </form>

      <div class="login-buttons recovery margin-top-l flex column">
        <div>
          <a @click="sendResetPassword()" class="button primary full">CADASTRAR NOVA SENHA</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { changePassword } from "@/services/auth";

export default {
  name: "change-password",
  props: ["rtoken"],
  data() {
    return {
      password1: "",
      password2: ""
    };
  },
  methods: {
    sendResetPassword() {
      if (this.password1 != this.password2) {
        return this.$toast.error({
          title: "Erro",
          message: "A senha digitada não confere com a sua repetição"
        });
      }
      changePassword({
        token: this.rtoken,
        password1: this.password1,
        password2: this.password2
      })
        .then(response => {
          this.$toast.success({
            title: "Sucesso",
            message: "Senha alterada com sucesso"
          });

          this.$store.dispatch("auth", { token: response.auth_token });
          this.$router.push({ name: "Account" });
        })
        .catch(error => {
          if (error && error.message === "request-canceled") {
            return;
          }

          return this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro interno"
          });
        });
    }
  }
};
</script>
